module.exports = __webpack_public_path__ + "img/service-entrance.32d4fe99.png";